import React from "react";
import {
  Avatar,
  Box,
  Button,
  HStack,
  VStack,
  StackDivider,
  Icon,
  Text,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  Portal
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { Session } from "types/session";
import { IoLocationOutline } from "react-icons/io5";
import { isActiveSession } from "utils/session";
import  useNames  from "hooks/useNames";

const SessionPopover: React.FC<Session> = (session: Session) => {
  const { id, title, start_time, end_time, participants, coach } = session;
  const { commaSeparatedList, firstNames, counterpart} = useNames();
  return (
    <Popover>
      <PopoverTrigger>
        <Box w="100%" height="100%" position="absolute" top={0} left={0} />
      </PopoverTrigger>
      <Portal>
        <PopoverContent
          fontSize="md"
          fontWeight="500"
          border="0"
          bg="gray.700"
          color="white"
          width="185px"
          margin="0 auto"
          boxShadow="0px 4px 7px -1px rgba(0, 0, 0, 0.25)"
          _focus={{
            boxShadow: "0px 4px 7px -1px rgba(0, 0, 0, 0.25)"
          }}
        >
          <PopoverBody p={3} overflow="hidden">
            <Text fontSize="15px" fontWeight={600}>
              &ldquo;{title}&rdquo;
            </Text>
            <Text fontSize="10px" fontWeight={400}>
              {format(new Date(start_time), "MMM d, yyy h:mm a")} -{" "}
              {format(new Date(end_time), "h:mm a")}
            </Text>
            <VStack
              spacing={2}
              mt={4}
              alignItems="flex-start"
              divider={<StackDivider borderColor="gray.900" />}
            >
              <HStack>
                <Icon as={IoLocationOutline} w={6} h={6} />
                <Text fontSize="9px" fontWeight={400}>
                  Charisma Coaching Call
                </Text>
              </HStack>
              <HStack>
                <Avatar
                  bg="blue.200"
                  color="gray.900"
                  name={firstNames(session)}
                  w={6}
                  h={6}
                />
                <VStack alignItems="flex-start" spacing={0}>
                  <Text fontSize="12px" fontWeight={500}>
                    {commaSeparatedList(session)}
                  </Text>
                  <Text fontSize="9px" fontWeight={400}>
                    {counterpart}
                  </Text>
                </VStack>
              </HStack>
              {isActiveSession(session) && (
                <Box alignSelf="center">
                  <Link to={`session/${id}/preview`}>
                    <Button my={2} variant="blue" size="sm">
                      Details
                    </Button>
                  </Link>
                </Box>
              )}
            </VStack>
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};

export default SessionPopover;
